import { fromJS } from 'immutable';
import {
  FETCH_ADDRESS_SUCCESS,
  FETCH_ADDRESS_FAILED,
  SELECT_ADDRESS_SUCCESS,
  ON_DATE_CHANGE
} from './actions';
import {
  POST_CODE_LIST,
  MANUALLY_CLICKED,
  POSTCODE_ERROR
} from '../../components/Address/addressUtils/addressConstants';
import {
  TYPE_UK_ADDRESS,
  MOVE_TO_DATE,
  MONTH_FIELD,
  YEAR_FIELD,
  ADDRESS_LIST,
  SELECTED_ADDRESS
} from '../../utils/constants';
import { validateAddressHistory } from '../../utils';
const addressTypes = [TYPE_UK_ADDRESS];
export const initialState = fromJS({
  loading: false,
  address: []
});

const addressReducer = (state = initialState, action) => {
  if (isValidIndex(action)) {
    const stateObj = state.toJS();
    const address = stateObj.address[action.meta.currentIndex] || {};
    const key = getActionKey(action, FETCH_ADDRESS_SUCCESS, address.addressList);
    const key_fail = getActionKey(action, FETCH_ADDRESS_FAILED, address.addressList);
    const key_select_address = getActionKey(action, SELECT_ADDRESS_SUCCESS, address.addressList);
    const ADD_MANUALLY_TYPE = `${getActionKey(
      action,
      MANUALLY_CLICKED,
      address.addressList
    )}${MANUALLY_CLICKED}`;
    const ADDRESS_SUCCESS = `${key}${FETCH_ADDRESS_SUCCESS}`;
    const ADDRESS_FAIL = `${key_fail}${FETCH_ADDRESS_FAILED}`;
    const SELECT_ADD_SUCCESS = `${key_select_address}${SELECT_ADDRESS_SUCCESS}`;
    switch (action.type) {
      case ADDRESS_FAIL:
        address[`${key_fail}${POST_CODE_LIST}`] = [];
        address[`${key_fail}${POSTCODE_ERROR}`] = true;
        break;
      case ADDRESS_SUCCESS:
        address[`${key}${POST_CODE_LIST}`] = fromJS(getAddress(action));
        address[`${key}${POSTCODE_ERROR}`] = getAddress(action).length === 0;
        address[`${key}ManuallyClickedValue`] = false;
        break;
      case ADD_MANUALLY_TYPE:
        address[`${ADD_MANUALLY_TYPE}Value`] = action.data;
        address[`${action.meta.key}${POSTCODE_ERROR}`] = false;
        break;
      case SELECT_ADD_SUCCESS:
        address[`${key_select_address}${SELECTED_ADDRESS}`] = action.payload;
        break;
      case `${getActionType(action)}${ON_DATE_CHANGE}`:
        address[MOVE_TO_DATE] = getMoveToDates(action, state);
        address[ADDRESS_LIST] = checkDateHistory(
          state,
          action.data.date,
          action.data.type,
          address
        );
        break;
      default:
        return state;
    }
    stateObj.address[action.meta.currentIndex] = address;
    return state.merge(fromJS(stateObj));
  }
  return state;
};

const checkDateHistory = (_state, date, type, address) => {
  const month = date[`${type}${MONTH_FIELD}`];
  const year = date[`${type}${YEAR_FIELD}`];
  const generatedDate = `01-${month}-${year}`;
  const noOfAddress = address.addressList || [];
  noOfAddress[0] = noOfAddress.length === 0 ? [] : noOfAddress[0];

  let addressList = noOfAddress[0] || [];
  addressList = removeAddressTypes(addressList, type);
  if (validateAddressHistory(generatedDate)) {
    addressTypes.push(`${TYPE_UK_ADDRESS}${addressList.length + 1}`);
    addressList.push(`${TYPE_UK_ADDRESS}${addressList.length + 1}`);
  }
  delete noOfAddress[0];
  noOfAddress[0] = addressList;
  return noOfAddress;
};

const removeAddressTypes = (addressList, type) => {
  const typeIndex = addressList.indexOf(type);
  return type === TYPE_UK_ADDRESS
    ? []
    : addressList.filter((_addType, index) => index <= typeIndex);
};

const getMoveToDates = (action, state) => {
  let datesList = state.get(MOVE_TO_DATE) || [];
  datesList = removeMoveToDates(datesList, action.data.type);
  const type = `${action.data.type}${MOVE_TO_DATE}`;
  datesList.push({ [type]: action.data.date });
  return datesList;
};

const removeMoveToDates = (datesList, type) => {
  const dateType = `${type}${MOVE_TO_DATE}`;
  let isAvailable = true;
  return dateType === `${TYPE_UK_ADDRESS}${MOVE_TO_DATE}`
    ? []
    : datesList.filter(moveToDate => {
        const dKey = Object.keys(moveToDate);
        if (dKey[0] === dateType) {
          isAvailable = false;
        }
        return isAvailable;
      });
};

const getActionType = action => (action && action.data ? action.data.type : '');

const getActionKey = (action, suffix, typesList) => {
  const list = typesList ? [TYPE_UK_ADDRESS].concat(typesList[0]) : addressTypes;
  return list.filter(v => action.type === `${v}${suffix}`)[0];
};

const isValidIndex = action => action.meta && action.meta.currentIndex > -1;

const getAddress = action => {
  return action.payload.short_addresses
    ? action.payload.short_addresses
    : formatAddress(action.payload);
};

const formatAddress = address => {
  return [
    {
      id: address.id,
      potential_address: `${address.address_line1}, ${address.city}, ${address.postcode}`
    }
  ];
};

export default addressReducer;
